import type { IPublicCourseResponse } from "../../../app/features/courses/courses.types";
import { enToBnNumber } from "../../../utils/number.utils";
import CourseCurriculum from "./CourseCurriculum";

type Props = {
  course?: IPublicCourseResponse;
  isLoading?: boolean;
};

export default function CourseDetails({ course, isLoading }: Props) {
  return (
    <section className="my-6">
      <h3 className="text-theme-zinc-700 text-2xl font-medium">
        কোর্সের বিষয়বস্তু
      </h3>
      <p className="text-theme-slate-500 text-base font-normal mb-6">
        {enToBnNumber(course?.CourseSection?.length || 0)}টি মডিউল
      </p>

      <CourseCurriculum isLoading={isLoading} course={course} />
    </section>
  );
}
